export default [{
    header: 'apps',
},
{
    title: 'Users',
    icon: 'UsersIcon',
    action: 'read',
    resource: 'PlatformUsers',
    children: [
        {
          title: 'User List',
          route: 'users-list',
          action: 'read',
          resource: 'PlatformUsers',
        },
    ],
},
{
    title: 'Staff',
    icon: 'ShieldIcon',
    action: 'read',
    resource: 'StaffUsers',
    children: [
        {
            title: 'Staff Users',
            route: 'staff-users',
            action: 'read',
            resource: 'StaffUsers',
        },
    ],
},
{
    title: 'Fundraisers',
    icon: "LayersIcon",
    action: 'read',
    resource: 'Fundraisers',
    children: [
        {
            title: 'Manage',
            route: 'fundraisers-manage',
            icon: 'GridIcon',
            action: 'read',
            resource: 'Fundraisers',
        },
        {
            title: 'Countries',
            route: 'fundraisers-countries',
            icon: 'TargetIcon',
            action: 'read',
            resource: 'Fundraisers',
        },
    ]
},
{
    title: 'Charities and nonprofits',
    icon: 'HeartIcon',
    action: 'read',
    resource: 'Charities',
    children: [
        {
            title: 'Manage',
            route: 'charities-manage',
            icon: 'GridIcon',
            action: 'read',
            resource: 'Charities',
        },
        {
            title: 'CRA registered charities',
            route: 'charities-cra',
            icon: 'DatabaseIcon',
            action: 'read',
            resource: 'Charities',
        },
        {
            title: 'Coupons',
            route: 'charities-coupons',
            icon: 'TagIcon',
            action: 'read',
            resource: 'Charities',
        },
    ]
},
{
    title: 'Events',
    icon: "LayersIcon",
    action: 'read',
    resource: 'Events',
    children: [
        {
            title: 'Manage',
            route: 'events-manage',
            icon: 'GridIcon',
            action: 'read',
            resource: 'Events',
        }
    ]
},
{
    title: 'Tickets',
    icon: 'TagIcon',
    action: 'read',
    resource: 'TicketEvents',
    children: [
        {
            title: 'Events',
            route: 'tickets-events',
            icon: 'CalendarIcon',
            action: 'read',
            resource: 'TicketEvents',
        },
        {
            title: 'Organizations',
            route: 'tickets-organizations',
            icon: 'BriefcaseIcon',
            action: 'read',
            resource: 'TicketEvents',
        },
    ]
},
{
    title: 'Transactions',
    icon: "ListIcon",
    action: 'read',
    resource: 'Transactions',
    children: [
        {
            title: 'Donations',
            route: 'transactions-donations',
            icon: 'FileTextIcon',
            action: 'read',
            resource: 'Transactions',
        },
        {
            title: 'Tickets',
            route: 'transactions-tickets',
            icon: 'FileTextIcon',
            action: 'read',
            resource: 'Transactions',
        },
    ]
},
{
    title: 'Surveys',
    icon: 'ClipboardIcon',
    action: 'read',
    resource: 'Surveys',
    children: [
        {
            title: 'Responses',
            route: 'surveys-responses',
            icon: 'ListIcon',
            action: 'read',
            resource: 'Surveys',
        },
    ],
},
]
